import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCountdown } from "../helper/Countdown";
import handleAddToCart from "./addtocartfunction";
const BestSellsOne = () => {
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  const [products, setProducts] = useState([]);

  const CK = process.env.REACT_APP_WC_CK;
  const CS = process.env.REACT_APP_WC_CS;
  const backend_url = process.env.REACT_APP_BACKEND_URL;

  //  Countdown Timer
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getCountdown());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  //  Fetch Daily Best Sells
  useEffect(() => {
  const fetchBestSells = async () => {
    try {
      const res = await fetch(`${backend_url}/api/best-sellers/`);
      const data = await res.json();

      if (data.status) {
        setProducts(data.data);
        
      } else {
        console.error("API Error:", data.error);
      }
    } catch (err) {
      console.error("Failed to load best sells", err);
    }
  };

  fetchBestSells();
}, []);

  return (
    <section className="best sells pb-80">
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0">Daily Best Sells</h5>
          </div>
        </div>

        <div className="row g-12">
          <div className="col-xxl-8">
            <div className="row gy-4">
              {products.map((p) => (
                <div key={p.product_id} className="col-md-6">
                  <div className="product-card style-two h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 flex-align gap-16">
                    <div>
                      <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                        Best
                      </span>

                      <Link
                         to={`/product-details/${p.product_id}`} 
                        className="product-card__thumb flex-center"
                      >
                        <img src={p.image} alt={p.name} />
                      </Link>

                      <div className="countdown">
                        <ul className="countdown-list style-three flex-align flex-wrap">
                          <li className="countdown-list__item text-heading">
                            {timeLeft.hours} Hours
                          </li>
                          <li className="countdown-list__item text-heading">
                            {timeLeft.minutes} Min
                          </li>
                          <li className="countdown-list__item text-heading">
                            {timeLeft.seconds} Sec
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="product-card__content">
                      <div className="product-card__price mb-16">
                        <span className="text-heading text-md fw-semibold">
                          ₹{p.price}{" "}
                          <span className="text-gray-500 fw-normal">/Qty</span>
                        </span>
                      </div>

                      <h6 className="title text-lg fw-semibold mt-12 mb-8">
                        <Link
                          to={`/product-details/${p.product_id}`} 
                          className="link text-line-2"
                        >
                          {p.name}
                        </Link>
                      </h6>

                      <div className="mt-12">
                        <div className="progress w-100 bg-color-three rounded-pill h-4">
                          <div
                            className="progress-bar bg-main-600 rounded-pill"
                            style={{
                              width: `${Math.min(p.items_sold * 25, 100)}%`,
                            }}
                          />
                        </div>
                        <span className="text-gray-900 text-xs fw-medium mt-8">
                          Sold Today: {p.items_sold}
                        </span>
                      </div>

                      <button onClick={() => handleAddToCart(p.product_id)}
                       
                        className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                      >
                        
                        Add To Cart <i className="ph ph-shopping-cart" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Static Promo Section */}
          <div className="col-xxl-4">
            <div className="position-relative rounded-16 bg-light-purple overflow-hidden p-28 z-1 text-center">
              <h4 className="mb-8">Special Snacks</h4>
              <div className="countdown my-32">
                <ul className="countdown-list style-two flex-center flex-wrap">
                  <li>{timeLeft.hours} Hours</li>
                  <li>{timeLeft.minutes} Min</li>
                  <li>{timeLeft.seconds} Sec</li>
                </ul>
              </div>
              <Link
                to="/shop"
                className="mt-16 btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
              >
                Shop Now <i className="ph ph-arrow-right" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestSellsOne;
